/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import networkConstant from '../../constants/network.constant';
import { SideBar } from '../../external/components/SideBar/SideBar';
import Text from '../../external/components/Text/Text';
import { State } from '../../reducers';
import { PoolType, StakingPool } from '../../services/staking/staking.types';
import { NetworkId } from '../../types/network.types';
import { StakingCardPreview } from './components/StakingCard';
import { StakingCardPreviewLp } from './components/StakingCardLp';
import { useStakingPools } from './hooks/useStakingPools';
import { ViewLPStakeBody } from './LpStakeSideBar/Body';
import { ViewStakeBody } from './ViewStakeSidebar/Body';
import Faq from '../../components/faq/index';

export default function Staking() {
  const [showViewStake, setShowViewStake] = useState(false);
  const [showViewLPStake, setShowViewLPStake] = useState(false);
  const [poolType] = useState<PoolType>('LP');
  const connected = localStorage.getItem('connected');
  let { networkId, stakingPoolsStore } = useSelector(({ account, StakingPools }: State) => ({
    networkId: account.networkId,
    stakingPoolsStore: StakingPools as StakingPool[],
  }));
  if (
    ![networkConstant.networkId.bscMainnet, networkConstant.networkId.bscTestnet].includes(
      networkId,
    )
  ) {
    networkId = 1;
  }

  const [networkIds] = useState<NetworkId[]>([networkId]);

  const [showStaked] = useState(false);
  const [showClosed] = useState(false);
  const [searchTerm] = useState('');
  const { stakingPools } = useStakingPools({ networkIds, poolType, searchTerm, showClosed });
  useEffect(() => {}, [stakingPools]);

  const [loading, setLoading] = useState(true);

  /*
  useEffect(() => {
    const total = stakingPoolsStore
      .filter((pool) => pool.networkId === networkIds[0])
      .reduce((acc, b) => {
        return acc + parseFloat(b.stakedBalanceUsd);
      }, 0);
    //setTotalUsd(total);
  }, [loading, stakingPools]);
  */

  return (
    <div className='container'>
      <div className='col-md-12'>
        <div className='col-md-12' style={{ textAlign: 'center' }}>
          <h1 style={{ margin: '0' }}>
            <Text dark={true} as='span' style={{ fontSize: '47px' }}>
              MLT Staking Platform
            </Text>
          </h1>
        </div>
        <SideBar show={showViewStake} setShow={setShowViewStake} dark={true}>
          <ViewStakeBody setShow={setShowViewStake} />
        </SideBar>
        <SideBar show={showViewLPStake} setShow={setShowViewLPStake} dark={true}>
          <ViewLPStakeBody setShow={setShowViewLPStake} />
        </SideBar>
      </div>
      <>
        {connected && connected.length > 3 && stakingPools && stakingPools.length > 0 ? (
          <div className='grid' style={{ margin: '-2rem 0 2.5rem 0', justifyContent: 'center' }}>
            <>
              {stakingPools.map((pool, i) =>
                pool.poolType === 'SINGLE' ? (
                  <StakingCardPreview
                    poolId={pool.stakingContractAddress}
                    showStaked={showStaked}
                    key={`nk-${i}`}
                    showSidebar={showViewStake}
                    stakingPools={stakingPools}
                    setShowSideBar={setShowViewStake}
                    setLoading={setLoading}
                  ></StakingCardPreview>
                ) : (
                  <StakingCardPreviewLp
                    poolId={pool.stakingContractAddress}
                    showStaked={showStaked}
                    key={`lp-${i}`}
                    showSidebar={showViewStake}
                    stakingPools={stakingPools}
                    setShowSideBar={setShowViewLPStake}
                    setLoading={setLoading}
                  ></StakingCardPreviewLp>
                ),
              )}
            </>
          </div>
        ) : (
          <div className='flex justify-center'>
            <Text dark={true}>
              You are connected to the wrong network. Please change to BSC in order to use our
              staking services.
            </Text>
          </div>
        )}
        <Faq />
      </>
    </div>
  );
}
